import PropTypes from 'prop-types';
import { Switch } from '@evertrue/et-components';

const SwitchInput = ({ onChange, onBlur, name, value, required = false, field, meta, helpers, label }) => {
  return (
    <Switch
      label={label || name || 'Switch Input'}
      name={name}
      showLabel={false}
      checked={value}
      onChange={(checked) => {
        onChange({ target: { name, value: checked } });
        onBlur({ target: { name } }); // the Switch component in ET Parts doesn't take in an onBlur prop, so we need to call it manually. not ideal
      }}
    />
  );
};

SwitchInput.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.bool,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
  label: PropTypes.string,
};

export default SwitchInput;
